export const tabs = [
  { label: 'Home', value: 'home' },
  { label: 'Voyages', value: 'voyages' },
  { label: 'Notes', value: 'notes' },
]
